export class TimeSheetDetailDto {
  public TimeSheetID: string;
  public DateSentToClient: Date;
  public SignedNotes: string;
  public TimeSheetName: string;

  public showNotes: boolean;
  public showFiles: boolean;
}
